import { Trans } from "react-i18next";

export const ChatbotDisclaimer = () => {
  return (
    <div className="w-full">
      <p className="text-ua-pink text-xs text-center pb-2"><Trans>Responses may not always be accurate and providing detail can improve accuracy</Trans></p>
    </div>
  );
};